import { useEffect, useRef, useState } from "react";

const WEBSOCKET_URL = "wss://backendvive-f0ebeuctgsekebbt.norwayeast-01.azurewebsites.net";

export const useWebSocketNOK = (userId) => {
  const socketRef = useRef(null);
  const [socketEvent, setSocketEvent] = useState(null);
  const [socketEventHealth, setSocketEventHealth] = useState(null);
  const [socketEventSettings, setSocketEventSettings] = useState(null);
  const [socketEventBP, setSocketEventBP] = useState(null);
  const [socketEventPulse, setSocketEventPulse] = useState(null);
  const [socketEventSPO2H, setSocketEventSPO2H] = useState(null);
  const [socketEventTemperature, setSocketEventTemperature] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) return;

    let ws = new WebSocket(WEBSOCKET_URL);
    console.log("🟡 Intentando conectar WebSocket con userId:", userId);

    ws.onopen = () => {
      console.log("✅ WebSocket abierto para userId:", userId);
      ws.send(JSON.stringify({ userId: parseInt(userId) }));
    };

    ws.onmessage = (event) => {
      try {
        const newMessage = JSON.parse(event.data);
        const incomingUserId = newMessage.userId ?? newMessage.payload?.userId;

        // Verifica si el mensaje corresponde al userId actual
        if (incomingUserId !== parseInt(userId)) {
          console.log("⛔ Ignorando datos de otro userId:", incomingUserId);
          return;
        }

        setSocketEvent(newMessage);

        if (newMessage.settingsAndState) {
          setSocketEventSettings(newMessage);
        } else if (newMessage.payload) {
          setSocketEventHealth(newMessage);

          switch (newMessage?.table) {
            case "userinpressure":
              setSocketEventBP({
                timestampSeconds: newMessage?.payload?.lastEntry,
                bpHigh: newMessage?.payload?.bpHigh,
                bpLow: newMessage?.payload?.bpLow,
              });
              break;
            case "userinfpulse":
              setSocketEventPulse({
                timestampSeconds: newMessage?.payload?.lastEntry,
                pulse: newMessage?.payload?.pulse,
              });
              break;
            case "userinfspo2hvalue":
              setSocketEventSPO2H({
                timestampSeconds: newMessage?.payload?.lastEntry,
                spo2hValue: newMessage?.payload?.Spo2hValue,
              });
              break;
            case "userinftemp":
              setSocketEventTemperature({
                timestampSeconds: newMessage?.payload?.lastEntry,
                temperature: newMessage?.payload?.temperature,
              });
              break;
            default:
              break;
          }
        }
      } catch (err) {
        console.error("❌ Error al parsear mensaje del WebSocket:", err);
      }
    };

    ws.onerror = (err) => {
      console.error("❌ WebSocket error:", err);
      setError(err);
    };

    ws.onclose = () => {
      console.warn("⚠️ WebSocket cerrado. Intentando reconectar...");
      setTimeout(() => {
        if (socketRef.current === ws) {
          // solo si es el mismo socket
          socketRef.current = null;
        }
      }, 3000);
    };

    // Cierra WebSocket anterior si hay uno activo
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      console.log("🔌 Cerrando WebSocket anterior...");
      socketRef.current.close();
    }

    socketRef.current = ws;

    return () => {
      if (socketRef.current) {
        console.log("🧹 Cerrando WebSocket en cleanup...");
        socketRef.current.close();
        socketRef.current = null;
      }
    };
  }, [userId]);

  const sendMessage = (message) => {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      socketRef.current.send(JSON.stringify(message));
    }
  };

  return {
    socketEvent,
    socketEventHealth,
    socketEventSettings,
    socketEventBP,
    socketEventPulse,
    socketEventSPO2H,
    socketEventTemperature,
    error,
    sendMessage,
  };
};
